/* Svensk katalog for locale-bank-archive-filter-no.js.
 * Nøkler som mangler her, vises på engelsk. */
window.PlummeI18n.register('sv', {
  'bank.archive.filter.postingType': 'Konteringstyp',
  'bank.archive.filter.purchase': 'Inköp',
  'bank.archive.filter.otherSale': 'Övrig försäljning',
  'bank.archive.filter.payment': 'Betalning',
  'bank.archive.filter.manualPosting': 'Fri kontering',
  'bank.archive.filter.bankPosting': 'Bankkontering',
  'bank.archive.filter.publicPayment': 'Lön och avgifter',
  'bank.archive.filter.ignored': 'Ignorerad bankrad',
  'bank.archive.filter.documentation': 'Dokumentation',
  'bank.archive.filter.missingAttachment': 'Saknar verifikation',
  'bank.archive.filter.hasAttachment': 'Har verifikation',
  'bank.archive.sort.label': 'Sortera konteringar',
  'bank.archive.sort.statementOrder': 'Ordning i kontoutdraget',
  'bank.archive.sort.dateDesc': 'Datum: nyaste först',
  'bank.archive.sort.dateAsc': 'Datum: äldsta först',
  'bank.archive.sort.amountDesc': 'Belopp: högst först',
  'bank.archive.sort.amountAsc': 'Belopp: lägst först',
});
